interface ConfigSet {
  clientCredsClientId: string | undefined;
  clientId: string | undefined;
  clientScope: string | undefined;
  clientSecret: string | undefined;
  lbApiHost: string | undefined;
  lbBaseURL: string | undefined;
  lbFallbackLoginUrl: string | undefined;
  ldClientKey: string | undefined;
  pendoApiKey: string | undefined;
  sentryDSN: string | undefined;
  sentryEnvironment: string | undefined;
}

export enum ConfigKeys {
  CLIENT_CREDS_CLIENT_ID = 'clientCredsClientId',
  CLIENT_ID = 'clientId',
  CLIENT_SCOPE = 'clientScope',
  CLIENT_SECRET = 'clientSecret',
  LB_FALLBACK_LOGIN_URL = 'lbFallbackLoginUrl',
  LB_API_HOST = 'lbApiHost',
  LB_BASE_URL = 'lbBaseURL',
  LAUNCH_DARKLY_CLIENT_KEY = 'ldClientKey',
  PENDO_API_KEY = 'pendoApiKey',
  SENTRY_DSN = 'sentryDSN',
  SENTRY_ENVIRONMENT = 'sentryEnvironment',
}

interface Config extends ConfigSet {
  getConfig: (urlName: keyof ConfigSet) => string | undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const env = (window as any).env ?? {};

export const ConfigHelper: Config = {
  clientCredsClientId: import.meta.env.VITE_CLIENT_ID,
  clientId: env.LB_CLIENT_ID ?? import.meta.env.VITE_LB_CLIENT_ID,
  clientScope: import.meta.env.VITE_CLIENT_SCOPE,
  clientSecret: import.meta.env.VITE_CLIENT_SECRET,
  getConfig(urlName) {
    return this[urlName];
  },
  lbApiHost: (() => {
    if (import.meta.env.VITE_NODE_ENV === 'development') {
      console.log('API: ', import.meta.env.VITE_LB_API_HOST);
    }

    return env.LB_API_HOST ?? import.meta.env.VITE_LB_API_HOST;
  })(),
  lbBaseURL: env.LB_BASE_URL ?? import.meta.env.VITE_LB_BASE_URL,
  lbFallbackLoginUrl: env.LB_FALLBACK_LOGIN_URL ?? '',
  ldClientKey: env.LAUNCH_DARKLY_CLIENT_KEY ?? import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_KEY,
  pendoApiKey: env.PENDO_API_KEY ?? import.meta.env.VITE_PENDO_API_KEY,
  sentryDSN: env.SENTRY_DSN ?? import.meta.env.VITE_SENTRY_DSN,
  sentryEnvironment: env.SENTRY_ENVIRONMENT ?? import.meta.env.VITE_SENTRY_ENVIRONMENT,
};
